import { loginPopup } from "@/Atoms";
import DrawerMyAngel from "@/components/mobile/drawer/drawer-my-angel";
import DrawerMyStartup from "@/components/mobile/drawer/drawer-my-startup";
import DrawerMyVC from "@/components/mobile/drawer/drawer-my-vc";
import DrawerTools from "@/components/mobile/drawer/drawer-tools";
import { useIsMobile } from "@/hooks/useIsMobile";
import {
  BookmarksSimple,
  ChalkboardTeacher,
  House,
  MagnifyingGlass,
  RocketLaunch,
} from "@phosphor-icons/react/dist/ssr";
import { useAtom } from "jotai";
import Link from "next/link";
import { useRouter } from "next/router";

export default function BottomNavigationMobile({ user, planSubscription }) {
  const isMobile = useIsMobile();
  const hasSubscription =
    planSubscription && planSubscription.has_active_subscription;
  const isStartupPlan = planSubscription && planSubscription.is_startup_plan;
  const isVCPlan = planSubscription && planSubscription.is_vc_plan;
  const isAngelInvestorPlan =
    planSubscription && planSubscription.is_angel_investor_plan;
  const [openLoginPopup, setOpenLoginPopup] = useAtom(loginPopup);
  const router = useRouter();

  const handleFavorites = () => {
    if (user) {
      router.push("/account/watchlist");
    } else {
      setOpenLoginPopup(true);
    }
  };
  return (
    <div className='fixed bottom-0 z-50 w-full'>
      <div className='grid grid-cols-5 items-center h-16 m-2 text-[10px] font-semibold text-center shadow-xl rounded-xl bg-gradient-to-tr from-yellow-1 to-red-1'>
        <Link href='/' className='flex flex-col items-center gap-[3px]'>
          <House weight='duotone' className='mx-auto text-2xl' />
          Home
        </Link>
        <Link href='/search' className='flex flex-col items-center gap-[3px]'>
          <MagnifyingGlass weight='duotone' className='mx-auto text-2xl' />
          Search
        </Link>
        <DrawerTools user={user} />
        <button
          type='button'
          onClick={handleFavorites}
          className='flex flex-col items-center gap-[3px]'
        >
          <BookmarksSimple weight='duotone' className='mx-auto text-2xl' />
          Favourites
        </button>
        {!hasSubscription ? (
          <Link
            href='https://calendly.com/lucy-viqk'
            target='_blank'
            className='flex flex-col items-center gap-[3px]'
          >
            <ChalkboardTeacher weight='duotone' className='mx-auto text-2xl' />
            Book Demo
          </Link>
        ) : isStartupPlan ? (
          <DrawerMyStartup />
        ) : isVCPlan ? (
          <DrawerMyVC />
        ) : isAngelInvestorPlan ? (
          <DrawerMyAngel />
        ) : null}
      </div>
    </div>
  );
}
